<template>
	<vx-card :title='$t("TransportTypes")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="transport_types">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addTransportTypePrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ transport_types.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : transport_types.length }} of {{ transport_types.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						{{ data[index].name }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addTransportTypePrompt">
			<div>
				<vs-checkbox class="mb-6" v-model="addCount">{{$t("CountKilometers")}}</vs-checkbox>
				<vs-checkbox class="mb-6" v-model="addAllowManual">{{$t("AllowManualUse")}}</vs-checkbox>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addName" style="width: 100%"></vs-input>
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addTransportType">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>

		<vs-popup :title="$t('Edit')" :active.sync="editTransportTypePrompt">
			<div>
				<vs-checkbox class="mb-6" v-model="editCount">{{$t("CountKilometers")}}</vs-checkbox>
				<vs-checkbox class="mb-6" v-model="editAllowManual">{{$t("AllowManualUse")}}</vs-checkbox>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="editName" style="width: 100%"></vs-input>
				<vs-divider/>
				<vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editTransportType">{{$t("Change")}}</vs-button>
				<vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeTransportType">{{$t("Delete")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	export default {
		data() {
			return {
				selected: {},
				transport_types: [],

				itemsPerPage: 20,
				isMounted: false,

				addTransportTypePrompt: false,
				editTransportTypePrompt: false,

				addName: '',
				addCount: false,
				addAllowManual: false,

				editName: '',
				editCount: false,
				editAllowManual: false,
			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
		},
		methods: {
			handleSelected(tr) {
				this.editName = tr.name;
				this.editCount = tr.count_kilometers;
				this.editAllowManual = tr.allow_manual_use;
				this.editTransportTypePrompt = true;
			},
			updateTransportTypes() {
				const thisIns = this;
				this.$http.get('/api/v1/transport_type/')
						.then(function (response) {
							thisIns.transport_types = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addTransportType() {
				const thisIns = this;
				this.$http.post('/api/v1/transport_type/', {
					name: thisIns.addName,
					count_kilometers: thisIns.addCount,
					allow_manual_use: thisIns.addAllowManual
				}).then(function () {
					thisIns.updateTransportTypes();
					thisIns.addTransportTypePrompt = false;
					thisIns.addName = "";
				}).catch(function (error) {
					thisIns.addTransportTypePrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			editTransportType() {
				const thisIns = this;
				this.$http.put('/api/v1/transport_type/' + this.selected.id, {
					name: thisIns.editName,
					count_kilometers: thisIns.editCount,
					allow_manual_use: thisIns.editAllowManual
				}).then(function () {
					thisIns.updateTransportTypes();
					thisIns.editTransportTypePrompt = false;
				}).catch(function (error) {
					thisIns.editTransportTypePrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			},
			removeTransportType() {
				const thisIns = this;
				this.$http.delete('/api/v1/transport_type/' + this.selected.id)
						.then(function () {
							thisIns.updateTransportTypes();
							thisIns.editTransportTypePrompt = false;
						}).catch(function (error) {
							thisIns.editTransportTypePrompt = false;
							thisIns.$vs.notify({
								title:'Error',
								text: error.response.data,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			}
		},
		watch: {
			editTransportTypePrompt: function () {
				if(!this.editTransportTypePrompt){
					this.selected = {}
				}
			}
		},
		created() {
			this.updateTransportTypes()
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addTransportTypePrompt){
				this.addTransportTypePrompt = false;
				next(false)
			}else if(this.editTransportTypePrompt){
				this.editTransportTypePrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
